import React from 'react';
import NumberFormat from 'react-number-format';

const Dinheiro = (props) => {
    let {value} = props;
   
    return <NumberFormat 
        decimalScale={2}
        thousandSeparator="."
        decimalSeparator=","
        prefix="R$ "
        fixedDecimalScale={true}
        displayType={'text'}
        defaultValue="0"
        value={value}
        
        {...props}></NumberFormat>
}

export {Dinheiro};